import { render } from "./Novosti.vue?vue&type=template&id=03ea3dce&scoped=true"
import script from "./Novosti.vue?vue&type=script&lang=js"
export * from "./Novosti.vue?vue&type=script&lang=js"

import "./Novosti.vue?vue&type=style&index=0&id=03ea3dce&scoped=true&lang=css"
import "./Novosti.vue?vue&type=style&index=1&id=03ea3dce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ea3dce"]])

export default __exports__